import { TableRow } from '@sam/components';
import { uid } from 'uid';
import { getUserNameForSimpleUser } from '../../../client/src/utils/user/User.utils';
import { SimpleUser } from '../user/User.types';
import {
  Car,
  CarType,
  EmployeeHistory,
  FuelType,
  TransmissionType,
  VehicleContractInformation,
} from './Car.types';

/**
 * Util method to create an empty car
 * @param userId to fill createdBy and updatedBy
 * @returns empty Car object
 */
export const generateEmptyCar = (override?: Partial<Car>): Car => {
  return {
    brand: '',
    milageHistories: [],
    createDate: new Date(),
    createdBy: '',
    enginePowerKw: 0,
    fuelType: FuelType.OTHER,
    grossListPrice: 0,
    id: undefined!,
    lastUpdated: new Date(),
    milage: 0,
    model: '',
    registrationDate: new Date(),
    registrationPlate: '',
    transmissionType: TransmissionType.MANUAL,
    updatedBy: '',
    userId: '',
    availableFrom: new Date(),
    comments: [],
    dealer: '',
    generalInspection: new Date(),
    officeId: '',
    seats: 0,
    vehicleContractInformation: generateEmptyVehicleContractInformation(),
    disabled: false,
    type: CarType.UNKNOWN,
    poolUsage: false,
    employeeHistories: [],
    ...override,
  };
};

/**
 * Util method to generate an empty vehicleContractInformation
 * @param override partial information to adjust the created object
 * @returns generated object
 */
export const generateEmptyVehicleContractInformation = (
  override?: Partial<VehicleContractInformation>,
): VehicleContractInformation => ({
  id: uid(),
  insurance: 0,
  insuranceNumber: '',
  leasingEnd: new Date(),
  leasingNumber: '',
  leasingRate: 0,
  priceKmOver: 0,
  priceKmUnder: 0,
  tax: 0,
  winterTyres: false,
  yearlyMilage: 15000,
  leasingStart: new Date(),
  milageLeasingStart: 0,
  fuelCard: '',
  fuelCardPin: '',
  servicePackage: false,
  ...override,
});

/**
 * Util method to convert the employeeHistory of a car to tableRows
 * @param historyEntries to display
 * @param users to display the usernames
 * @returns array of TableRows
 */
export const convertEmployeeHistoryInTableEntries = (
  historyEntries: EmployeeHistory[] = [],
  users: SimpleUser[],
): TableRow[] => {
  return historyEntries.map((history) => ({
    id: history.id,
    content: [
      history.createDate.toLocaleDateString('DE-de'),
      getUserNameForSimpleUser(history.createdBy, users),
      getUserNameForSimpleUser(history.oldUserId, users),
      getUserNameForSimpleUser(history.newUserId, users),
    ],
  }));
};
